export enum AnalisyType{
    ORGANIZATION    =   "OR",
    SITE            =   "SI"
}